module.exports = __webpack_public_path__ + "static/media/定标套件.447e004c.png";